import { EventEmitter } from 'events';

export default class Store extends EventEmitter {
	emit(eventType) {
		if (eventType === undefined)
			throw new Error('Trying to emit undefined event type');
		super.emit(eventType);
	}
}
